import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { MyToursPageDto } from '../../../../../api/MyTours';
import * as moment from 'moment-timezone';
import { useState } from 'react';
import TourReschedulePopup from './TourReschedulePopup';
import TourCancelPopup from './TourCancelPopup';
import StartTourPopup from '../applessTour/StartTourPopup';
import MyToursPageButtons from './MyToursPageButtons';
import { PreferredTourFormat, TourStatuses, TourType } from '../../../../../utilities/Enums';
import { Link } from 'react-router-dom';
import { prospectPath, prospectPages } from '../../ProspectRouter';
import { Event } from '../../../../../api/Property';
import { stringify } from 'querystring';
import { browserHistory } from '../../../../../utilities/history';
import { buildGoogleMapQuery } from '../../../../../utilities/Utils';
import { HelpEmailLink } from '../../../../common/HelpLinks';
// import { atcb_init } from 'add-to-calendar-button';
import 'add-to-calendar-button/assets/css/atcb.css';
// import AddToCalendar from 'react-add-to-calendar';

interface Props {
    tourInfo: MyToursPageDto;
}

const IndividualTourDisplay = (props: Props) => {
    const completeLogo = require('../../../../../images/tour-completed.png');
    const notScheduledLogo = require('../../../../../images/tour-not-scheduled.svg');
    const logo = require('../../../../../images/logo-color.png');
    const [tourInfo, setTourInfo] = useState<MyToursPageDto>(props.tourInfo);
    const [reschedulePopupIsOpen, setReschedulePopupIsOpen] = useState(false);
    const [cancelPopupIsOpen, setCancelPopupIsOpen] = useState(false);
    const [startTourPopupIsOpen, setStartTourPopupIsOpen] = useState(false);
    // React.useEffect(atcb_init, []);

    function getTimeZone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    let tourStatusStyling = '';
    let desc = `You have a self-guided tour scheduled at ${tourInfo.propertyName}.\n\n[br][br]Please download the Tour24 app before arriving.\n\n[br][br][url]https://apps.apple.com/gb/app/tour-24-self-guided-apt-tour/id1462185580|Download Tour24 from the App Store[/url]\n\n[br][br][url]https://play.google.com/store/apps/details?id=com.toursphere.tour24|Download Tour24 from Google Play[/url]\n\n[br][br]Access to the property is only valid during your scheduled time.\n\n[br][br]Tap [url]https://app.tour24now.com/prospect/login|Sign In [/url] / My Tours to start your Tour.\n Use the same phone number and password you used to register for your account.\n\n[br][br]Need to Reschedule? [url]https://app.tour24now.com/prospect/login|Sign In[/url] to your Tour24 account and go to the My Tours page.`;

    const isVirtualTour = tourInfo.preferredTourFormat === PreferredTourFormat.Virtual;

    if (
        (tourInfo.tour && tourInfo.tour.tourStatus === TourStatuses.Complete) ||
        tourInfo.virtualTourCompleted
    ) {
        tourStatusStyling = 'tour-status-complete';
    } else if (tourInfo.tour || isVirtualTour) {
        tourStatusStyling = 'tour-status';
    } else {
        tourStatusStyling = 'tour-status-signup-incomplete';
    }

    interface TourStatusDisplay {
        mainTitle: string;
        subtitle?: string;
        icon?: any;
    }

    const formatTourStatusDisplay: () => TourStatusDisplay = () => {
        if (tourInfo.tour === null || tourInfo.tour === undefined) {
            if (!isVirtualTour) {
                return {
                    mainTitle: 'Signup Incomplete',
                    subtitle: 'This tour HAS NOT been scheduled yet!',
                    icon: notScheduledLogo
                };
            }

            if (tourInfo.virtualTourCompleted) {
                return { mainTitle: 'Completed Virtually', icon: completeLogo };
            }
            return { mainTitle: 'Virtual Tour' };
        }
        if (tourInfo.tour.tourStatus === TourStatuses.NoShow) {
            return { mainTitle: 'We missed you!', subtitle: "Sorry you didn't make your tour." };
        }
        if (tourInfo.tour.tourStatus === TourStatuses.Complete) {
            return { mainTitle: 'Completed', icon: completeLogo };
        }

        return { mainTitle: tourInfo.tour.tourStatus.toString() };
    };

    const handleOpenStartTourModal = () => {
        if (
            (tourInfo.tour && tourInfo.tour.tourType !== TourType.Appless) ||
            tourInfo.preferredTourFormat === PreferredTourFormat.Virtual
        ) {
            setStartTourPopupIsOpen(true);
            return;
        }
        return (
            tourInfo.tour &&
            browserHistory.push(
                `${prospectPath(prospectPages.startTour)}/${tourInfo.tour.tourGuid}`
            )
        );
    };

    const name = `Tour 24 - ${tourInfo.propertyName}`;
    const startDate = tourInfo.tour && moment.tz(tourInfo.tour.tourStart, getTimeZone()).format('YYYY-MM-DD');
    const endDate = tourInfo.tour && moment.tz(tourInfo.tour.tourEnd, getTimeZone()).format('YYYY-MM-DD');
    const startTime = tourInfo.tour && moment.tz(tourInfo.tour.tourStart, getTimeZone()).format('HH:mm');
    const endTime = tourInfo.tour && moment.tz(tourInfo.tour.tourEnd, getTimeZone()).format('HH:mm');
    // }
    const location = tourInfo.propertyCity + ',' + tourInfo.propertyState;
    const timeZone = getTimeZone();

    return (
        <div className="tour-display-shadow">
            <div>
                {tourInfo.tour && (
                    <TourReschedulePopup
                        propertyName={tourInfo.propertyName}
                        propertyId={tourInfo.propertyId}
                        tour={tourInfo.tour}
                        guestCardGuid={tourInfo.guestCardGuid}
                        isOpen={reschedulePopupIsOpen}
                        close={() => setReschedulePopupIsOpen(false)}
                        setTourTime={(timeslot: Event) =>
                            setTourInfo({
                                ...tourInfo,
                                tour: {
                                    ...tourInfo.tour!,
                                    tourStart: timeslot.startDateTime,
                                    tourEnd: timeslot.endDateTime
                                }
                            })
                        }
                    />
                )}
                {tourInfo.tour && (
                    <TourCancelPopup
                        isOpen={cancelPopupIsOpen}
                        close={() => setCancelPopupIsOpen(false)}
                        tour={tourInfo.tour}
                        guestCardGuid={tourInfo.guestCardGuid}
                        setTourStatus={(status: TourStatuses) =>
                            setTourInfo({
                                ...tourInfo,
                                tour: { ...tourInfo.tour!, tourStatus: status }
                            })
                        }
                    />
                )}
                {(tourInfo.tour || isVirtualTour) && (
                    <StartTourPopup
                        isOpen={startTourPopupIsOpen}
                        close={() => setStartTourPopupIsOpen(false)}
                        appless={
                            tourInfo.tour !== undefined &&
                            tourInfo.tour !== null &&
                            tourInfo.tour.tourType === TourType.Appless
                        }
                    />
                )}
            </div>
            <Row className="tour-display-row">
                <Col lg={3} className="d-none d-lg-block tour-property-image-col">
                    <div
                        className="center-cropped"
                        style={{ backgroundImage: `url('${tourInfo.propertyImage}')` }}
                    />
                </Col>
                <Col xs={12} lg={9} className="tour-display-main-content">
                    <section className="tour-display-box">
                        <Row>
                            <Col className="col-4 tour-property-column">
                                <section>
                                    <Link
                                        to={`${prospectPath(prospectPages.properties)}?${stringify({
                                            search: tourInfo.propertySlug
                                        })}`}
                                    >
                                        <label className="tour-property-name">
                                            {tourInfo.propertyName}
                                        </label>
                                    </Link>
                                </section>
                                <section>
                                    <p>
                                        <a
                                            href={buildGoogleMapQuery(
                                                tourInfo.propertyStreetAddress,
                                                tourInfo.propertyCity,
                                                tourInfo.propertyState,
                                                tourInfo.propertyZipCode
                                            )}
                                        >
                                            {tourInfo.propertyStreetAddress && (
                                                <>
                                                    <span>{tourInfo.propertyStreetAddress}</span>
                                                    <br />
                                                </>
                                            )}

                                            <span>
                                                {tourInfo.propertyCity}, {tourInfo.propertyState}{' '}
                                                {tourInfo.propertyZipCode}
                                            </span>
                                        </a>
                                    </p>
                                </section>
                            </Col>
                            <Col size={8} className="tour-status-column">
                                <div>
                                    {formatTourStatusDisplay().icon && (
                                        <img
                                            className="tour-status-icon"
                                            src={formatTourStatusDisplay().icon}
                                        />
                                    )}
                                    <label className={tourStatusStyling}>
                                        {formatTourStatusDisplay().mainTitle}
                                    </label>
                                    <div className="atcb-wrapper">
                                    {startDate &&
                                         <div className="atcb">
                                         {'{'}
                                         "name":"{name}",
                                         "description":"{desc}",
                                         "startDate": "{startDate}",
                                         "endDate":"{endDate}",
                                         "startTime":"{startTime}",
                                         "endTime":"{endTime}",
                                         "location":"{location}",
                                         "label":"Add to Calendar",
                                         "options":[
                                         "Apple",
                                         "Google",
                                         "iCal",
                                         "Microsoft365",
                                         "Outlook.com",
                                         "Yahoo"
                                         ],
                                         "timeZone":"{timeZone}",
                                         "iCalFileName":"Reminder-Event",
                                         "trigger":"click",
                                         "customLabels":"true"
                                         {'}'}
                                     </div>
                                    }
                                    </div>
                                   
                                </div>
                                {formatTourStatusDisplay().subtitle && (
                                    <label className="status-subtitle">
                                        {formatTourStatusDisplay().subtitle}
                                    </label>
                                )}
                            </Col>
                        </Row>
                        <Row className="tour-date-and-logo-row">
                            <Col className="col-6 tour-date-column">
                                <section>
                                    <label className="tour-date">
                                        {tourInfo.tour !== undefined && tourInfo.tour !== null
                                            ? moment(tourInfo.tour.tourStart).format(
                                                'MMMM DD, YYYY'
                                            )
                                            : ''}
                                    </label>
                                </section>
                                <section>
                                    <label className="tour-start-end">
                                        {tourInfo.tour !== undefined && tourInfo.tour !== null
                                            ? `${moment(tourInfo.tour.tourStart).format(
                                                'h:mm'
                                            )} - ${moment(tourInfo.tour.tourEnd).format(
                                                'h:mm A'
                                            )}`
                                            : ''}
                                    </label>
                                </section>
                            </Col>
                            <Col size={6} className="tour-status-column">
                                <Row className="tour24-logo-container">
                                    <img src={logo} />
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6} className="help-text-col">
                                <label className="tour-help-text">
                                    Questions?{' '}
                                    <Link
                                        to={
                                            tourInfo.tour &&
                                                tourInfo.tour.tourType === TourType.Appless
                                                ? prospectPath(prospectPages.webTourFaq)
                                                : prospectPath(prospectPages.tour24Faq)
                                        }
                                    >
                                        Try our FAQs
                                    </Link>
                                </label>
                                <HelpEmailLink className="tour-help-email" />
                            </Col>
                            <MyToursPageButtons
                                tourInfo={tourInfo}
                                openCancelPopup={() => setCancelPopupIsOpen(true)}
                                openReschedulePopup={() => setReschedulePopupIsOpen(true)}
                                openStartTourPopup={handleOpenStartTourModal}
                            />
                        </Row>
                    </section>
                </Col>
            </Row>
        </div>
    );
};

export default IndividualTourDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/allTours/IndividualTourDisplay.tsx